(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["454-order-planner"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('order-planner-454')) {
  customElements.define('order-planner-454', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('[data-planner-form]');
      this.form.hidden = false;
      this.form.addEventListener('submit', event => { event.preventDefault(); this.calculate(); });
      this.form.addEventListener('input', () => { this.querySelector('[data-planner-output]').hidden = true; this.querySelector('[data-planner-error]').hidden = true; });
      this.form.addEventListener('change', () => this.calculate());
      this.calculate();
    }
    calculate() {
      const amount = Number(this.querySelector('[data-amount]').value);
      const cycles = Number(this.querySelector('[data-cycles]')?.value || 1);
      const option = this.querySelector('[data-planner-variant]').selectedOptions[0];
      const units = Number(option.dataset.units);
      const capacity = Number(option.dataset.capacity);
      const valid = this.form.checkValidity() && amount > 0 && cycles > 0 && units > 0 && capacity > 0;
      this.querySelector('[data-planner-error]').hidden = valid;
      this.querySelector('[data-planner-output]').hidden = !valid;
      if (!valid) return;
      const needed = this.dataset.mode === 'bags' ? Math.ceil(amount / capacity) : amount * cycles;
      const minimum = Number(option.dataset.min) || 1;
      const step = Number(option.dataset.step) || 1;
      const packs = Math.ceil(Math.max(minimum, Math.ceil(needed / units)) / step) * step;
      const maximum = Number(option.dataset.max) || Infinity;
      const supplied = packs * units;
      const values = {needed, packs, supplied, spare: supplied - needed, rolls: packs * Number(option.dataset.rolls)};
      for (const [key, value] of Object.entries(values)) {
        const target = this.querySelector('[data-planner-output] [data-' + key + ']');
        if (target) target.textContent = value.toLocaleString(this.dataset.locale);
      }
      const formatter = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency, currencyDisplay: 'code' });
      this.querySelector('[data-cost]').textContent = formatter.format(packs * Number(option.dataset.price) / 100);
      this.querySelector('[data-limit]').hidden = packs <= maximum;
      this.querySelector('[data-unavailable]').hidden = option.dataset.available === 'true';
      const url = new URL(this.dataset.url, location.origin);
      url.searchParams.set('variant', option.value);
      const current = new URL(location.href);
      for (const key of ['preview_theme_id', '_fd', 'pb']) if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
      this.querySelector('[data-choice]').href = url.href;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["454-quick-view"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quick-view-454')) {
  customElements.define('quick-view-454', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.owner = this.closest('collection-454');
      this.dialog = this.querySelector('dialog');
      if (!this.owner || !this.dialog.showModal) return;
      this.content = this.querySelector('[data-qv-content]');
      this.status = this.querySelector('[data-qv-status]');
      this.fallback = this.querySelector('[data-qv-fallback]');
      this.owner.setAttribute('data-quick-view-ready','');
      this.onTrigger = event => {
        const trigger = event.target.closest('[data-quick-view]');
        if (!trigger || this.adding) return;
        event.preventDefault();
        this.trigger = trigger;
        this.content.replaceChildren();
        this.dialog.removeAttribute('aria-labelledby');
        this.dialog.showModal();
        document.documentElement.classList.add('q454-open');
        this.load(new URL(trigger.dataset.productUrl,location.origin));
      };
      this.owner.addEventListener('click',this.onTrigger);
      this.dialog.addEventListener('close',() => {
        this.request?.abort();
        document.documentElement.classList.remove('q454-open');
        if (this.trigger?.isConnected) this.trigger.focus({preventScroll:true});
      });
      this.dialog.addEventListener('click',event => {
        if (event.target.closest('[data-qv-close]')) this.dialog.close();
        if (event.target === this.dialog) {
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        }
        const thumb = event.target.closest('[data-qv-image]');
        if (thumb) {
          const img = this.content.querySelector('.q454-main-image');
          img.src = thumb.dataset.qvImage;
          img.removeAttribute('srcset');
          img.alt = thumb.dataset.alt;
          this.content.querySelectorAll('[data-qv-image]').forEach(button=>button.setAttribute('aria-pressed',String(button === thumb)));
        }
      });
      this.dialog.addEventListener('change',event => {
        if (!event.target.matches('[data-qv-option]') || this.adding) return;
        const product = this.content.querySelector('[data-qv-product]');
        const option = event.target.selectedOptions[0];
        const url = new URL(option.dataset.productUrl || product.dataset.url,location.origin);
        url.searchParams.set('option_values',[...product.querySelectorAll('[data-qv-option]')].map(select=>select.value).join(','));
        this.load(url,event.target.id);
      });
      this.dialog.addEventListener('submit',event => this.addToCart(event));
    }
    disconnectedCallback() {
      this.request?.abort();
      this.owner?.removeEventListener('click',this.onTrigger);
      if (this.dialog?.open) {this.dialog.close();document.documentElement.classList.remove('q454-open');}
    }
    async load(url,focusId) {
      this.request?.abort();
      const request = new AbortController();
      this.request = request;
      const quantity = this.content.querySelector('[name=quantity]')?.value;
      this.content.setAttribute('aria-busy','true');
      const currentButton = this.content.querySelector('[type=submit]');
      if (currentButton) currentButton.disabled = true;
      this.status.textContent = this.dataset.loading;
      this.fallback.href = url.href;
      this.fallback.hidden = true;
      const fetchURL = new URL(url);
      fetchURL.searchParams.set('section_id','454-quick-view');
      for (const key of ['preview_theme_id','_fd','pb']) {
        const value = new URL(location.href).searchParams.get(key);
        if (value) fetchURL.searchParams.set(key,value);
      }
      try {
        const response = await fetch(fetchURL,{signal:request.signal});
        if (!response.ok) throw new Error('Quick view unavailable');
        const parsed = new DOMParser().parseFromString(await response.text(),'text/html');
        const product = parsed.querySelector('[data-qv-product]');
        if (!product) throw new Error('Quick view missing');
        if (request.signal.aborted || !this.dialog.open) return;
        this.content.replaceChildren(product);
        this.dialog.setAttribute('aria-labelledby',product.querySelector('h2').id);
        const input = product.querySelector('[name=quantity]');
        if (focusId && input && quantity) {input.value=quantity;if(!input.checkValidity())input.value=input.min||1;}
        this.status.textContent = '';
        if (focusId) product.querySelector('#'+CSS.escape(focusId))?.focus({preventScroll:true});
        else this.dialog.querySelector('[data-qv-close]').focus({preventScroll:true});
      } catch(error) {
        if (error.name !== 'AbortError') {this.status.textContent=this.dataset.error;this.fallback.hidden=false;}
      } finally {
        if (this.request === request) this.content.removeAttribute('aria-busy');
      }
    }
    async addToCart(event) {
      const form = event.target;
      if (!form.matches('[data-qv-form]')) return;
      event.preventDefault();
      if (this.adding || !form.reportValidity()) return;
      const button = form.querySelector('[type=submit]');
      if (button.disabled) return;
      const status = form.querySelector('[data-qv-form-status]');
      const data = new FormData(form);
      data.set('sections','cart-icon-bubble');
      data.set('sections_url',location.pathname);
      this.adding = true;
      button.disabled = true;
      button.setAttribute('aria-busy','true');
      const selects = [...form.querySelectorAll('[data-qv-option]')];
      selects.forEach(select=>select.disabled=true);
      status.textContent = '';
      status.classList.remove('is-error');
      try {
        const response = await fetch(this.dataset.cartAdd,{method:'POST',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'},body:data});
        const result = await response.json();
        if (!response.ok || result.status) {status.textContent=result.description||result.message||this.dataset.addError;status.classList.add('is-error');return;}
        status.textContent=this.dataset.added;
        form.querySelector('[data-qv-cart]').hidden=false;
        if (result.sections?.['cart-icon-bubble']) {
          const parsed=new DOMParser().parseFromString(result.sections['cart-icon-bubble'],'text/html');
          const incoming=parsed.querySelector('.shopify-section');
          const bubble=document.getElementById('cart-icon-bubble');
          if (incoming && bubble) bubble.innerHTML=incoming.innerHTML;
        }
        this.dispatchEvent(new CustomEvent('454:quick-view-added',{bubbles:true,detail:{variantId:data.get('id'),quantity:Number(data.get('quantity'))||1}}));
        try {
          if (await window.F454BundleUpgrade?.afterAdd({variantId:Number(data.get('id')),quantity:Number(data.get('quantity'))||1,sellingPlan:null,onDismiss:()=>{}})) this.dialog.close();
        } catch (_) {}
      } catch (_) {
        status.textContent=this.dataset.addError;
        status.classList.add('is-error');
        form.querySelector('[data-qv-cart]').hidden=false;
      } finally {
        this.adding=false;
        button.disabled=false;
        button.removeAttribute('aria-busy');
        selects.forEach(select=>select.disabled=false);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-454-mega-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('supply-navigation-454')) {
  customElements.define('supply-navigation-454', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const opts = { signal: this.controller.signal };
      this.disclosures = [...this.querySelectorAll('.supply454__disclosure')];
      this.desktop = matchMedia('(min-width: 990px)');
      this.hover = matchMedia('(hover: hover) and (pointer: fine)');
      const closeAll = (except) => this.disclosures.forEach(d => { if (d !== except) d.open = false; });
      this.closeAll = closeAll;
      this.disclosures.forEach(details => {
        const summary = details.querySelector('summary');
        details.addEventListener('pointerenter', () => {
          clearTimeout(this.closeTimer);
          clearTimeout(this.openTimer);
          if (!this.desktop.matches || !this.hover.matches) return;
          this.openTimer = setTimeout(() => { closeAll(details); details.open = true; }, 90);
        }, opts);
        details.addEventListener('pointerleave', () => {
          clearTimeout(this.openTimer);
          this.closeTimer = setTimeout(() => { if (!details.contains(document.activeElement)) details.open = false; }, 220);
        }, opts);
        details.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(details.open));
          if (details.open) closeAll(details);
        }, opts);
        summary.addEventListener('click', () => { clearTimeout(this.openTimer); clearTimeout(this.closeTimer); }, opts);
        summary.addEventListener('keydown', event => {
          if (event.key !== 'ArrowDown') return;
          event.preventDefault();
          closeAll(details);
          details.open = true;
          details.querySelector('.supply454__panel a')?.focus();
        }, opts);
      });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        const open = this.disclosures.find(d => d.open);
        if (!open) return;
        event.preventDefault();
        clearTimeout(this.openTimer);
        open.open = false;
        open.querySelector('summary').focus();
      }, opts);
      this.addEventListener('focusout', () => {
        requestAnimationFrame(() => { this.disclosures.forEach(d => { if (!d.contains(document.activeElement)) d.open = false; }); });
      }, opts);
      document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) { clearTimeout(this.openTimer); closeAll(); } }, opts);
      this.desktop.addEventListener('change', () => closeAll(), opts);
      this.header = this.closest('sticky-header');
      if (this.header) {
        const original = this.header.getAttribute('data-sticky-type');
        const updateSticky = () => {
          this.header.headerIsAlwaysSticky = this.desktop.matches || Boolean(this.header.querySelector('supply-mobile-454')) || original === 'always' || original === 'reduce-logo-size';
          const section = this.closest('.section-header');
          section?.classList.toggle('shopify-section-header-sticky', this.header.headerIsAlwaysSticky);
          if (this.header.headerIsAlwaysSticky) section?.classList.remove('shopify-section-header-hidden');
        };
        this.desktop.addEventListener('change', updateSticky, opts);
        customElements.whenDefined('sticky-header').then(() => { if (this.isConnected) updateSticky(); });
      }
    }
    disconnectedCallback() {
      clearTimeout(this.openTimer);
      clearTimeout(this.closeTimer);
      this.controller?.abort();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-454-mobile-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('supply-mobile-454')) {
  customElements.define('supply-mobile-454', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('.m454__open');
      this.mobile = matchMedia('(max-width: 989px)');
      this.scrollArea = this.querySelector('.m454__scroll');
      this.trigger.addEventListener('click', () => {
        if (!this.mobile.matches || this.dialog.open) return;
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.dialog.showModal();
        this.trigger.setAttribute('aria-expanded', 'true');
      }, options);
      this.querySelector('.m454__close').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow || '';
        this.trigger.setAttribute('aria-expanded', 'false');
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target.closest('a[href]')) this.dialog.close();
      }, options);
      this.querySelectorAll('.m454__group, .m454__preferences').forEach(group => {
        const summary = group.querySelector('summary');
        summary.setAttribute('role', 'button');
        summary.setAttribute('aria-expanded', String(group.open));
        group.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(group.open));
          if (!group.open || !group.classList.contains('m454__group')) return;
          this.querySelectorAll('.m454__group').forEach(other => { if (other !== group) other.open = false; });
          requestAnimationFrame(() => {
            const top = group.getBoundingClientRect().top - this.scrollArea.getBoundingClientRect().top;
            if (top < 0) this.scrollArea.scrollTop += top - 8;
          });
        }, options);
      });
      this.currency = document.getElementById('country-currency-display');
      this.currencyParent = this.currency?.parentNode;
      this.currencyNext = this.currency?.nextSibling;
      this.currencySlot = this.querySelector('[data-mobile-currency-slot]');
      this.header = this.closest('sticky-header');
      this.syncLayout = () => {
        if (!this.mobile.matches && this.dialog.open) this.dialog.close();
        if (this.currency) {
          if (this.mobile.matches && this.currency.parentNode !== this.currencySlot) this.currencySlot.append(this.currency);
          else if (!this.mobile.matches) this.restoreCurrency();
        }
        if (this.header) {
          const original = this.header.getAttribute('data-sticky-type');
          this.header.headerIsAlwaysSticky = this.mobile.matches || Boolean(this.header.querySelector('supply-navigation-454')) || original === 'always' || original === 'reduce-logo-size';
          const section = this.closest('.section-header');
          section?.classList.toggle('shopify-section-header-sticky', this.header.headerIsAlwaysSticky);
          if (this.header.headerIsAlwaysSticky) section?.classList.remove('shopify-section-header-hidden');
        }
      };
      this.mobile.addEventListener('change', this.syncLayout, options);
      this.syncLayout();
      customElements.whenDefined('sticky-header').then(() => { if (this.isConnected) this.syncLayout(); });
    }
    restoreCurrency() {
      if (!this.currency || !this.currencyParent || this.currency.parentNode === this.currencyParent) return;
      if (this.currencyNext?.parentNode === this.currencyParent) this.currencyParent.insertBefore(this.currency, this.currencyNext);
      else this.currencyParent.prepend(this.currency);
    }
    disconnectedCallback() {
      if (this.dialog?.open) { this.dialog.close(); document.body.style.overflow = this.previousOverflow || ''; }
      this.restoreCurrency();
      this.controller?.abort();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
